import React, { useState } from 'react';
import { Card, Nav, NavItem, NavLink, TabContent, TabPane,Row,Col } from 'reactstrap';
import classnames from 'classnames';
import { Link} from "react-router-dom";
import ContactsDetails from '../components/ContactsDetails';
import DatoTab from './DatoTab'
import DocumentoContacto from '../components/DocumentoContacto'
import CasosContacto from './CasosContacto';

const ProfileTab = ({contactos=[]})=> {
    

    
    const [activeTab, setActiveTab] = useState('1');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }
    return (
        <React.Fragment>
            <Card className="mb-0">
                <Nav pills justified  role="tablist">
                    <NavItem>
                        <NavLink
                            to="#"
                            className={classnames({ active: activeTab === '1' })}
                            onClick={() => { toggle('1'); }}
                        >
                            <i className="mdi mdi-book-open font-size-20"></i>
                            <span className="d-none d-sm-block">Casos</span>
                        </NavLink>
                    </NavItem>
                   
                    <NavItem>
                        <NavLink
                            to="#"
                            className={classnames({ active: activeTab === '2' })}
                            onClick={() => { toggle('2'); }}>
                            <i className="mdi mdi-card-account-details font-size-20"></i>
                            <span className="d-none d-sm-block">Datos del contacto</span>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            to="#"
                            className={classnames({ active: activeTab === '3' })}
                            onClick={() => { toggle('3'); }}
                        >
                            <i className="mdi mdi-clipboard-text-outline font-size-20"></i>
                            <span className="d-none d-sm-block">Documentos del Contacto</span>
                        </NavLink>
                    </NavItem>

                    <NavItem>
                        <NavLink
                            to="#"
                            className={classnames({ active: activeTab === '4' })}
                            onClick={() => { toggle('4'); }}>
                            <i className="mdi mdi-account-circle-outline font-size-20"></i>
                            <span className="d-none d-sm-block">Información General</span>
                        </NavLink>
                    </NavItem>
                </Nav>

                <TabContent className="p-4" activeTab={activeTab}>
                   
                    <TabPane id="casos" role="tabpanel" tabId="1">
                                          <CasosContacto>

                                          </CasosContacto>
                        </TabPane>
                    
                    <TabPane id="documentos" role="tabpanel" tabId="2">
                        <DatoTab/>
                        </TabPane>
                    
                    <TabPane id="datosContactos" role="tabpanel" tabId="3">
                       <DocumentoContacto/>
                        </TabPane>
                    
                    <TabPane id="contactsDetails" role="tabpanel" tabId="4">

                       <ContactsDetails contactos = {contactos}/>
                       </TabPane>

                </TabContent>
                <Row className="col-lg-12 justify-content-center">
                    <Col className="mb-3" md={1}>
                      <Link className="btn btn-secondary " to={`/contacts`}>
                        Volver
                      </Link>
                    </Col>
                  </Row>
            </Card>
        </React.Fragment>
    );
}

export default ProfileTab;